<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <QuestionWrapper
        v-bind="{...$props, ...$attrs}"
        @event="$emit('event', $event)">
        <template #question>
            <h2>{{ question.questionText }}</h2>
            <p v-html="question.comments" />
        </template>

        <template #persons="{answer, personKey, person, personName}">
            <QuestionAnswers
                :answer="answer"
                :person-key="personKey"
                :person-name="personName"
                :question="question"
                :registrar-mode="registrarMode"
                @event="$emit('event', $event)" />
        </template>
    </QuestionWrapper>
</template>

<script>
import questionMixin from "@/components/pages/registration/questions/questionMixin";
import QuestionAnswers from "@/components/pages/registration/questions/answer/QuestionAnswers";

export default {
    name: "QuestionQuestion",
    components: {QuestionAnswers},
    mixins: [questionMixin],
}
</script>

<style scoped>

</style>
